import { sentenceCase } from 'change-case';
import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { BaseSummaryProps } from './types';
import { YesNoLabel } from './utils';


export const AgreementSummary = ({ application }: BaseSummaryProps) => {
  const steps = useRentalSteps({slug: slugs.agreement});
  const accepted = (<YesNoLabel value={!!application?.acceptedAgreement ?? false} />);
  const errors = application?.validation?.agreement;
  const isInvalid = !!errors;

  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Review Rental Agreement</SummaryHeader>
      {!application ? <LoadingLabel alignment="left" /> : (
        <div className={cs(isInvalid && 'text-danger')}>
          <div>I have read and agree to the Terms &amp; Conditions: {accepted}</div>
          <div>I agree to rent from The Polygon Group Pty Ltd: {accepted}</div>
          <div>I acknowledge this application is subject to an approval process: {accepted}</div>
          {isInvalid && (
            <div className="small">
              {errors?.map(e => `${sentenceCase(e.field)}: ${e.messages.join(' ')}`)}
            </div>
          )}
        </div>
      )}
    </SummarySection>
  );
}
